import { useCallback, useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { BomPartType, ComponentStatus } from 'bom/enums';
import { BomPartHelper } from 'bom/helpers';
import { Button } from 'core/components';
import { useAgGridClientTableContext } from 'core/states';
import { IJobPart } from 'jobs/types';
import { Color, Variant } from 'theme/enums';

import { UpsertComponent } from './UpsertComponent';

export const UpsertComponentButton = () => {
  const [isOpen, setIsOpen] = useState(false);

  const { t } = useTranslation();

  const { selectedRows, updateRows } = useAgGridClientTableContext();

  const selectedJobPart = useMemo(() => {
    if (
      selectedRows.length === 1 &&
      selectedRows[0].type === BomPartType.PART &&
      selectedRows[0].status !== ComponentStatus.DELETED
    ) {
      return selectedRows[0] as IJobPart;
    }

    return null;
  }, [selectedRows]);

  const isDisabled = useMemo(() => !selectedJobPart, [selectedJobPart]);

  const buttonLabel = useMemo(() => {
    if (BomPartHelper.hasComponentAssigned(selectedJobPart)) {
      return t('buttonLabelEditComponentName');
    }

    return t('buttonLabelAddComponentName');
  }, [selectedJobPart, t]);

  const onSubmitSuccess = useCallback(
    (updatedJobPart: IJobPart) => {
      setTimeout(() => {
        updateRows({ update: [updatedJobPart] });
      }, 1000);
    },
    [updateRows]
  );

  return (
    <>
      <Button
        text={buttonLabel}
        variant={Variant.OUTLINED}
        color={Color.NEUTRAL}
        onClick={() => setIsOpen(true)}
        disabled={isDisabled}
      />

      {selectedJobPart && (
        <UpsertComponent
          isOpen={isOpen}
          onClose={() => setIsOpen(false)}
          jobPart={selectedJobPart}
          onSubmitSuccess={onSubmitSuccess}
        />
      )}
    </>
  );
};
